/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
 !function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},a.each(["onResize","onThrottledResize"],a.proxy(function(b,c){this._handlers[c]=a.proxy(this[c],this)},this)),a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a.charAt(0).toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Workers,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}e.Defaults={items:3,loop:!1,center:!1,rewind:!1,checkVisibility:!0,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,fallbackEasing:"swing",slideTransition:"",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Type={Event:"event",State:"state"},e.Plugins={},e.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(a){var b=this.settings.margin||"",c=!this.settings.autoWidth,d=this.settings.rtl,e={width:"auto","margin-left":d?b:"","margin-right":d?"":b};!c&&this.$stage.children().css(e),a.css=e}},{filter:["width","items","settings"],run:function(a){var b=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,c=null,d=this._items.length,e=!this.settings.autoWidth,f=[];for(a.items={merge:!1,width:b};d--;)c=this._mergers[d],c=this.settings.mergeFit&&Math.min(c,this.settings.items)||c,a.items.merge=c>1||a.items.merge,f[d]=e?b*c:this._items[d].width();this._widths=f}},{filter:["items","settings"],run:function(){var b=[],c=this._items,d=this.settings,e=Math.max(2*d.items,4),f=2*Math.ceil(c.length/2),g=d.loop&&c.length?d.rewind?e:Math.max(e,f):0,h="",i="";for(g/=2;g>0;)b.push(this.normalize(b.length/2,!0)),h+=c[b[b.length-1]][0].outerHTML,b.push(this.normalize(c.length-1-(b.length-1)/2,!0)),i=c[b[b.length-1]][0].outerHTML+i,g-=1;this._clones=b,a(h).addClass("cloned").appendTo(this.$stage),a(i).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var a=this.settings.rtl?1:-1,b=this._clones.length+this._items.length,c=-1,d=0,e=0,f=[];++c<b;)d=f[c-1]||0,e=this._widths[this.relative(c)]+this.settings.margin,f.push(d+e*a);this._coordinates=f}},{filter:["width","items","settings"],run:function(){var a=this.settings.stagePadding,b=this._coordinates,c={width:Math.ceil(Math.abs(b[b.length-1]))+2*a,"padding-left":a||"","padding-right":a||""};this.$stage.css(c)}},{filter:["width","items","settings"],run:function(a){var b=this._coordinates.length,c=!this.settings.autoWidth,d=this.$stage.children();if(c&&a.items.merge)for(;b--;)a.css.width=this._widths[this.relative(b)],d.eq(b).css(a.css);else c&&(a.css.width=a.items.width,d.css(a.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(a){a.current=a.current?this.$stage.children().index(a.current):0,a.current=Math.max(this.minimum(),Math.min(this.maximum(),a.current)),this.reset(a.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;c<d;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass("active"),this.$stage.children(".center").removeClass("center"),this.settings.center&&this.$stage.children().eq(this.current()).addClass("center")}}],e.prototype.initializeStage=function(){this.$stage=this.$element.find("."+this.settings.stageClass),this.$stage.length||(this.$element.addClass(this.options.loadingClass),this.$stage=a("<"+this.settings.stageElement+">",{class:this.settings.stageClass}).wrap(a("<div/>",{class:this.settings.stageOuterClass})),this.$element.append(this.$stage.parent()))},e.prototype.initializeItems=function(){var b=this.$element.find(".owl-item");if(b.length)return this._items=b.get().map(function(b){return a(b)}),this._mergers=this._items.map(function(){return 1}),void this.refresh();this.replace(this.$element.children().not(this.$stage.parent())),this.isVisible()?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)},e.prototype.initialize=function(){if(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading")){var a,b,c;a=this.$element.find("img"),b=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,c=this.$element.children(b).width(),a.length&&c<=0&&this.preloadAutoWidthImages(a)}this.initializeStage(),this.initializeItems(),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},e.prototype.isVisible=function(){return!this.settings.checkVisibility||this.$element.is(":visible")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){a<=b&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),"function"==typeof e.stagePadding&&(e.stagePadding=e.stagePadding()),delete e.responsive,e.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+d))):e=a.extend({},this.options),this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},e.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};b<c;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={},!this.is("valid")&&this.enter("valid")},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return!!this._items.length&&(this._width!==this.$element.width()&&(!!this.isVisible()&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))))},e.prototype.registerEventHandlers=function(){a.support.transition&&this.$stage.on(a.support.transition.end+".owl.core",a.proxy(this.onTransitionEnd,this)),!1!==this.settings.responsive&&this.on(b,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",a.proxy(this.onDragEnd,this)))},e.prototype.onDragStart=function(b){var d=null;3!==b.which&&(a.support.transform?(d=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","),d={x:d[16===d.length?12:4],y:d[16===d.length?13:5]}):(d=this.$stage.position(),d={x:this.settings.rtl?d.left+this.$stage.width()-this.width()+this.settings.margin:d.left,y:d.top}),this.is("animating")&&(a.support.transform?this.animate(d.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===b.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=a(b.target),this._drag.stage.start=d,this._drag.stage.current=d,this._drag.pointer=this.pointer(b),a(c).on("mouseup.owl.core touchend.owl.core",a.proxy(this.onDragEnd,this)),a(c).one("mousemove.owl.core touchmove.owl.core",a.proxy(function(b){var d=this.difference(this._drag.pointer,this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core",a.proxy(this.onDragMove,this)),Math.abs(d.x)<Math.abs(d.y)&&this.is("valid")||(b.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},e.prototype.onDragMove=function(a){var b=null,c=null,d=null,e=this.difference(this._drag.pointer,this.pointer(a)),f=this.difference(this._drag.stage.start,e);this.is("dragging")&&(a.preventDefault(),this.settings.loop?(b=this.coordinates(this.minimum()),c=this.coordinates(this.maximum()+1)-b,f.x=((f.x-b)%c+c)%c+b):(b=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),c=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),d=this.settings.pullDrag?-1*e.x/5:0,f.x=Math.max(Math.min(f.x,b+d),c+d)),this._drag.stage.current=f,this.animate(f.x))},e.prototype.onDragEnd=function(b){var d=this.difference(this._drag.pointer,this.pointer(b)),e=this._drag.stage.current,f=d.x>0^this.settings.rtl?"left":"right";a(c).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==d.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(e.x,0!==d.x?f:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=f,(Math.abs(d.x)>3||(new Date).getTime()-this._drag.time>300)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},e.prototype.closest=function(b,c){var e=-1,f=30,g=this.width(),h=this.coordinates();return this.settings.freeDrag||a.each(h,a.proxy(function(a,i){return"left"===c&&b>i-f&&b<i+f?e=a:"right"===c&&b>i-g-f&&b<i-g+f?e=a+1:this.op(b,"<",i)&&this.op(b,">",h[a+1]!==d?h[a+1]:i-g)&&(e="left"===c?a+1:a),-1===e},this)),this.settings.loop||(this.op(b,">",h[this.minimum()])?e=b=this.minimum():this.op(b,"<",h[this.maximum()])&&(e=b=this.maximum())),e},e.prototype.animate=function(b){var c=this.speed()>0;this.is("animating")&&this.onTransitionEnd(),c&&(this.enter("animating"),this.trigger("translate")),a.support.transform3d&&a.support.transition?this.$stage.css({transform:"translate3d("+b+"px,0px,0px)",transition:this.speed()/1e3+"s"+(this.settings.slideTransition?" "+this.settings.slideTransition:"")}):c?this.$stage.animate({left:b+"px"},this.speed(),this.settings.fallbackEasing,a.proxy(this.onTransitionEnd,this)):this.$stage.css({left:b+"px"})},e.prototype.is=function(a){return this._states.current[a]&&this._states.current[a]>0},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(b){return"string"===a.type(b)&&(this._invalidated[b]=!0,this.is("valid")&&this.leave("valid")),a.map(this._invalidated,function(a,b){return b})},e.prototype.reset=function(a){(a=this.normalize(a))!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(a,b){var c=this._items.length,e=b?0:this._clones.length;return!this.isNumeric(a)||c<1?a=d:(a<0||a>=c+e)&&(a=((a-e/2)%c+c)%c+e/2),a},e.prototype.relative=function(a){return a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=this.settings,f=this._coordinates.length;if(e.loop)f=this._clones.length/2+this._items.length-1;else if(e.autoWidth||e.merge){if(b=this._items.length)for(c=this._items[--b].width(),d=this.$element.width();b--&&!((c+=this._items[b].width()+this.settings.margin)>d););f=b+1}else f=e.center?this._items.length-1:this._items.length-e.items;return a&&(f-=this._clones.length/2),Math.max(f,0)},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2==0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c,e=1,f=b-1;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(this.settings.rtl&&(e=-1,f=b+1),c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[f]||0))/2*e):c=this._coordinates[f]||0,c=Math.ceil(c))},e.prototype.duration=function(a,b,c){return 0===c?0:Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(a,b){var c=this.current(),d=null,e=a-this.relative(c),f=(e>0)-(e<0),g=this._items.length,h=this.minimum(),i=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(e)>g/2&&(e+=-1*f*g),a=c+e,(d=((a-h)%g+g)%g+h)!==a&&d-e<=i&&d-e>0&&(c=d-e,a=d,this.reset(c))):this.settings.rewind?(i+=1,a=(a%i+i)%i):a=Math.max(h,Math.min(i,a)),this.speed(this.duration(c,a,b)),this.current(a),this.isVisible()&&this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.onTransitionEnd=function(a){if(a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},e.prototype.viewport=function(){var d;return this.options.responsiveBaseElement!==b?d=a(this.options.responsiveBaseElement).width():b.innerWidth?d=b.innerWidth:c.documentElement&&c.documentElement.clientWidth?d=c.documentElement.clientWidth:console.warn("Can not detect viewport width."),d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(b,c){var e=this.relative(this._current);c=c===d?this._items.length:this.normalize(c,!0),b=b instanceof jQuery?b:a(b),this.trigger("add",{content:b,position:c}),b=this.prepare(b),0===this._items.length||c===this._items.length?(0===this._items.length&&this.$stage.append(b),0!==this._items.length&&this._items[c-1].after(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[c].before(b),this._items.splice(c,0,b),this._mergers.splice(c,0,1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[e]&&this.reset(this._items[e].index()),this.invalidate("items"),this.trigger("added",{content:b,position:c})},e.prototype.remove=function(a){(a=this.normalize(a,!0))!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.preloadAutoWidthImages=function(b){b.each(a.proxy(function(b,c){this.enter("pre-loading"),c=a(c),a(new Image).one("load",a.proxy(function(a){c.attr("src",a.target.src),c.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",c.attr("src")||c.attr("data-src")||c.attr("data-src-retina"))},this))},e.prototype.destroy=function(){this.$element.off(".owl.core"),this.$stage.off(".owl.core"),a(c).off(".owl.core"),!1!==this.settings.responsive&&(b.clearTimeout(this.resizeTimer),this.off(b,"resize",this._handlers.onThrottledResize));for(var d in this._plugins)this._plugins[d].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.remove(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:a<c;case">":return d?a<c:a>c;case">=":return d?a<=c:a>=c;case"<=":return d?a>=c:a<=c}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d,f,g){var h={item:{count:this._items.length,index:this.current()}},i=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),j=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},h,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(j)}),this.register({type:e.Type.Event,name:b}),this.$element.trigger(j),this.settings&&"function"==typeof this.settings[i]&&this.settings[i].call(this,j)),j},e.prototype.enter=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]===d&&(this._states.current[b]=0),this._states.current[b]++},this))},e.prototype.leave=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]--},this))},e.prototype.register=function(b){if(b.type===e.Type.Event){if(a.event.special[b.name]||(a.event.special[b.name]={}),!a.event.special[b.name].owl){var c=a.event.special[b.name]._default;a.event.special[b.name]._default=function(a){return!c||!c.apply||a.namespace&&-1!==a.namespace.indexOf("owl")?a.namespace&&a.namespace.indexOf("owl")>-1:c.apply(this,arguments)},a.event.special[b.name].owl=!0}}else b.type===e.Type.State&&(this._states.tags[b.name]?this._states.tags[b.name]=this._states.tags[b.name].concat(b.tags):this._states.tags[b.name]=b.tags,this._states.tags[b.name]=a.grep(this._states.tags[b.name],a.proxy(function(c,d){return a.inArray(c,this._states.tags[b.name])===d},this)))},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.pointer=function(a){var c={x:null,y:null};return a=a.originalEvent||a||b.event,a=a.touches&&a.touches.length?a.touches[0]:a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:a,a.pageX?(c.x=a.pageX,c.y=a.pageY):(c.x=a.clientX,c.y=a.clientY),c},e.prototype.isNumeric=function(a){return!isNaN(parseFloat(a))},e.prototype.difference=function(a,b){return{x:a.x-b.x,y:a.y-b.y}},a.fn.owlCarousel=function(b){var c=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a(this),f=d.data("owl.carousel");f||(f=new e(this,"object"==typeof b&&b),d.data("owl.carousel",f),a.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(b,c){f.register({type:e.Type.Event,name:c}),f.$element.on(c+".owl.carousel.core",a.proxy(function(a){a.namespace&&a.relatedTarget!==this&&(this.suppress([c]),f[c].apply(this,[].slice.call(arguments,1)),this.release([c]))},f))})),"string"==typeof b&&"_"!==b.charAt(0)&&f[b].apply(f,c)})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoRefresh:!0,autoRefreshInterval:500},e.prototype.watch=function(){this._interval||(this._visible=this._core.isVisible(),this._interval=b.setInterval(a.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},e.prototype.refresh=function(){this._core.isVisible()!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},e.prototype.destroy=function(){var a,c;b.clearInterval(this._interval);for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoRefresh=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type)){var c=this._core.settings,e=c.center&&Math.ceil(c.items/2)||c.items,f=c.center&&-1*e||0,g=(b.property&&b.property.value!==d?b.property.value:this._core.current())+f,h=this._core.clones().length,i=a.proxy(function(a,b){this.load(b)},this);for(c.lazyLoadEager>0&&(e+=c.lazyLoadEager,c.loop&&(g-=c.lazyLoadEager,e++));f++<e;)this.load(h/2+this._core.relative(g)),h&&a.each(this._core.clones(this._core.relative(g)),i),g++}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={lazyLoad:!1,lazyLoadEager:0},e.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src")||f.attr("data-srcset");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):f.is("source")?f.one("load.owl.lazy",a.proxy(function(){this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("srcset",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":'url("'+g+'")',opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(c){this._core=c,this._previousHeight=null,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&"position"===a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._intervalId=null;var d=this;a(b).on("load",function(){d._core.settings.autoHeight&&d.update()}),a(b).resize(function(){d._core.settings.autoHeight&&(null!=d._intervalId&&clearTimeout(d._intervalId),d._intervalId=setTimeout(function(){d.update()},250))})};e.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},e.prototype.update=function(){var b=this._core._current,c=b+this._core.settings.items,d=this._core.settings.lazyLoad,e=this._core.$stage.children().toArray().slice(b,c),f=[],g=0;a.each(e,function(b,c){f.push(a(c).height())}),g=Math.max.apply(null,f),g<=1&&d&&this._previousHeight&&(g=this._previousHeight),this._previousHeight=g,this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass)},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.video&&this.isInFullScreen()&&a.preventDefault()},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};e.Defaults={video:!1,videoHeight:!1,videoWidth:!1},e.prototype.fetch=function(a,b){var c=function(){return a.attr("data-vimeo-id")?"vimeo":a.attr("data-vzaar-id")?"vzaar":"youtube"}(),d=a.attr("data-vimeo-id")||a.attr("data-youtube-id")||a.attr("data-vzaar-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else if(d[3].indexOf("vimeo")>-1)c="vimeo";else{if(!(d[3].indexOf("vzaar")>-1))throw new Error("Video URL not supported.");c="vzaar"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},e.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?"width:"+c.width+"px;height:"+c.height+"px;":"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(c){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?a("<div/>",{class:"owl-video-tn "+j,srcType:c}):a("<div/>",{class:"owl-video-tn",style:"opacity:1;background-image:url("+c+")"}),b.after(d),b.after(e)};if(b.wrap(a("<div/>",{class:"owl-video-wrapper",style:g})),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length)return l(h.attr(i)),h.remove(),!1;"youtube"===c.type?(f="//img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type?a.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}):"vzaar"===c.type&&a.ajax({type:"GET",url:"//vzaar.com/api/videos/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a.framegrab_url,l(f)}})},e.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},e.prototype.play=function(b){var c,d=a(b.target),e=d.closest("."+this._core.settings.itemClass),f=this._videos[e.attr("data-video")],g=f.width||"100%",h=f.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),e=this._core.items(this._core.relative(e.index())),this._core.reset(e.index()),c=a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'),c.attr("height",h),c.attr("width",g),"youtube"===f.type?c.attr("src","//www.youtube.com/embed/"+f.id+"?autoplay=1&rel=0&v="+f.id):"vimeo"===f.type?c.attr("src","//player.vimeo.com/video/"+f.id+"?autoplay=1"):"vzaar"===f.type&&c.attr("src","//view.vzaar.com/"+f.id+"/player?autoplay=true"),a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),this._playing=e.addClass("owl-video-playing"))},e.prototype.isInFullScreen=function(){var b=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return b&&a(b).parent().hasClass("owl-video-frame")},e.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){a.namespace&&(this.swapping="translated"==a.type)},this),"translate.owl.carousel":a.proxy(function(a){a.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,
 animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&a.support.animation&&a.support.transition){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.one(a.support.animation.end,c).css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g)),f&&e.one(a.support.animation.end,c).addClass("animated owl-animated-in").addClass(f))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._call=null,this._time=0,this._timeout=0,this._paused=!0,this._handlers={"changed.owl.carousel":a.proxy(function(a){a.namespace&&"settings"===a.property.name?this._core.settings.autoplay?this.play():this.stop():a.namespace&&"position"===a.property.name&&this._paused&&(this._time=0)},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":a.proxy(function(a,b,c){a.namespace&&this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(a){a.namespace&&this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=a.extend({},e.Defaults,this._core.options)};e.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},e.prototype._next=function(d){this._call=b.setTimeout(a.proxy(this._next,this,d),this._timeout*(Math.round(this.read()/this._timeout)+1)-this.read()),this._core.is("interacting")||c.hidden||this._core.next(d||this._core.settings.autoplaySpeed)},e.prototype.read=function(){return(new Date).getTime()-this._time},e.prototype.play=function(c,d){var e;this._core.is("rotating")||this._core.enter("rotating"),c=c||this._core.settings.autoplayTimeout,e=Math.min(this._time%(this._timeout||c),c),this._paused?(this._time=this.read(),this._paused=!1):b.clearTimeout(this._call),this._time+=this.read()%c-e,this._timeout=c,this._call=b.setTimeout(a.proxy(this._next,this,d),c-e)},e.prototype.stop=function(){this._core.is("rotating")&&(this._time=0,this._paused=!0,b.clearTimeout(this._call),this._core.leave("rotating"))},e.prototype.pause=function(){this._core.is("rotating")&&!this._paused&&(this._time=this.read(),this._paused=!0,b.clearTimeout(this._call))},e.prototype.destroy=function(){var a,b;this.stop();for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(b){this._core=b,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){b.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,0,this._templates.pop())},this),"remove.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&this.draw()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers)};e.Defaults={nav:!1,navText:['<span aria-label="Previous">&#x2039;</span>','<span aria-label="Next">&#x203a;</span>'],navSpeed:!1,navElement:'button type="button" role="presentation"',navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},e.prototype.initialize=function(){var b,c=this._core.settings;this._controls.$relative=(c.navContainer?a(c.navContainer):a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=a("<"+c.navElement+">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click",a.proxy(function(a){this.prev(c.navSpeed)},this)),this._controls.$next=a("<"+c.navElement+">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click",a.proxy(function(a){this.next(c.navSpeed)},this)),c.dotsData||(this._templates=[a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),this._controls.$absolute=(c.dotsContainer?a(c.dotsContainer):a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","button",a.proxy(function(b){var d=a(b.target).parent().is(this._controls.$absolute)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(d,c.dotsSpeed)},this));for(b in this._overrides)this._core[b]=a.proxy(this[b],this)},e.prototype.destroy=function(){var a,b,c,d,e;e=this._core.settings;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)"$relative"===b&&e.navContainer?this._controls[b].html(""):this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},e.prototype.update=function(){var a,b,c,d=this._core.clones().length/2,e=d+this._core.items().length,f=this._core.maximum(!0),g=this._core.settings,h=g.center||g.autoWidth||g.dotsData?1:g.dotsEach||g.items;if("page"!==g.slideBy&&(g.slideBy=Math.min(g.slideBy,g.items)),g.dots||"page"==g.slideBy)for(this._pages=[],a=d,b=0,c=0;a<e;a++){if(b>=h||0===b){if(this._pages.push({start:Math.min(f,a-d),end:a-d+h-1}),Math.min(f,a-d)===f)break;b=0,++c}b+=this._core.mergers(this._core.relative(a))}},e.prototype.draw=function(){var b,c=this._core.settings,d=this._core.items().length<=c.items,e=this._core.relative(this._core.current()),f=c.loop||c.rewind;this._controls.$relative.toggleClass("disabled",!c.nav||d),c.nav&&(this._controls.$previous.toggleClass("disabled",!f&&e<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!f&&e>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!c.dots||d),c.dots&&(b=this._pages.length-this._controls.$absolute.children().length,c.dotsData&&0!==b?this._controls.$absolute.html(this._templates.join("")):b>0?this._controls.$absolute.append(new Array(b+1).join(this._templates[0])):b<0&&this._controls.$absolute.children().slice(b).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(a.inArray(this.current(),this._pages)).addClass("active"))},e.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotsData?1:c.dotsEach||c.items)}},e.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,a.proxy(function(a,c){return a.start<=b&&a.end>=b},this)).pop()},e.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},e.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},e.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},e.prototype.to=function(b,c,d){var e;!d&&this._pages.length?(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c)):a.proxy(this._overrides.to,this._core)(b,c)},a.fn.owlCarousel.Constructor.Plugins.Navigation=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(c){this._core=c,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(c){c.namespace&&"URLHash"===this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!c)return;this._hashes[c]=b.content}},this),"changed.owl.carousel":a.proxy(function(c){if(c.namespace&&"position"===c.property.name){var d=this._core.items(this._core.relative(this._core.current())),e=a.map(this._hashes,function(a,b){return a===d?b:null}).join();if(!e||b.location.hash.slice(1)===e)return;b.location.hash=e}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(a){var c=b.location.hash.substring(1),e=this._core.$stage.children(),f=this._hashes[c]&&e.index(this._hashes[c]);f!==d&&f!==this._core.current()&&this._core.to(this._core.relative(f),!1,!0)},this))};e.Defaults={URLhashListener:!1},e.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){function e(b,c){var e=!1,f=b.charAt(0).toUpperCase()+b.slice(1);return a.each((b+" "+h.join(f+" ")+f).split(" "),function(a,b){if(g[b]!==d)return e=!c||b,!1}),e}function f(a){return e(a,!0)}var g=a("<support>").get(0).style,h="Webkit Moz O ms".split(" "),i={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},j={csstransforms:function(){return!!e("transform")},csstransforms3d:function(){return!!e("perspective")},csstransitions:function(){return!!e("transition")},cssanimations:function(){return!!e("animation")}};j.csstransitions()&&(a.support.transition=new String(f("transition")),a.support.transition.end=i.transition.end[a.support.transition]),j.cssanimations()&&(a.support.animation=new String(f("animation")),a.support.animation.end=i.animation.end[a.support.animation]),j.csstransforms()&&(a.support.transform=new String(f("transform")),a.support.transform3d=j.csstransforms3d())}(window.Zepto||window.jQuery,window,document);
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).GreenAudioPlayer=e()}}(function(){return function n(l,r,o){function u(t,e){if(!r[t]){if(!l[t]){var i="function"==typeof require&&require;if(!e&&i)return i(t,!0);if(d)return d(t,!0);var s=new Error("Cannot find module '"+t+"'");throw s.code="MODULE_NOT_FOUND",s}var a=r[t]={exports:{}};l[t][0].call(a.exports,function(e){return u(l[t][1][e]||e)},a,a.exports,n,l,r,o)}return r[t].exports}for(var d="function"==typeof require&&require,e=0;e<o.length;e++)u(o[e]);return u}({1:[function(e,t,i){"use strict";t.exports=e("./src/js/main").default},{"./src/js/main":2}],2:[function(e,t,i){"use strict";function n(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var i=[],s=!0,a=!1,n=void 0;try{for(var l,r=e[Symbol.iterator]();!(s=(l=r.next()).done)&&(i.push(l.value),!t||i.length!==t);s=!0);}catch(e){a=!0,n=e}finally{try{s||null==r.return||r.return()}finally{if(a)throw n}}return i}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function s(e,t){for(var i=0;i<t.length;i++){var s=t[i];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,s.key,s)}}Object.defineProperty(i,"__esModule",{value:!0}),i.default=void 0;var a=function(){function u(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,u),this.audioPlayer="string"==typeof e?document.querySelector(e):e;var i=t||{},s=this.audioPlayer.innerHTML;this.audioPlayer.classList.add("green-audio-player"),this.audioPlayer.innerHTML=u.getTemplate()+s,this.isDevice=/ipad|iphone|ipod|android/i.test(window.navigator.userAgent.toLowerCase())&&!window.MSStream,this.playPauseBtn=this.audioPlayer.querySelector(".play-pause-btn"),this.loading=this.audioPlayer.querySelector(".loading"),this.sliders=this.audioPlayer.querySelectorAll(".slider"),this.progress=this.audioPlayer.querySelector(".controls__progress"),this.volumeBtn=this.audioPlayer.querySelector(".volume__button"),this.volumeControls=this.audioPlayer.querySelector(".volume__controls"),this.volumeProgress=this.volumeControls.querySelector(".volume__progress"),this.player=this.audioPlayer.querySelector("audio"),this.currentTime=this.audioPlayer.querySelector(".controls__current-time"),this.totalTime=this.audioPlayer.querySelector(".controls__total-time"),this.speaker=this.audioPlayer.querySelector(".volume__speaker"),this.download=this.audioPlayer.querySelector(".download"),this.downloadLink=this.audioPlayer.querySelector(".download__link"),this.span=this.audioPlayer.querySelectorAll(".message__offscreen"),this.svg=this.audioPlayer.getElementsByTagName("svg"),this.img=this.audioPlayer.getElementsByTagName("img"),this.draggableClasses=["pin"],this.currentlyDragged=null,this.stopOthersOnPlay=i.stopOthersOnPlay||!1,this.enableKeystrokes=i.enableKeystrokes||!1,this.showTooltips=i.showTooltips||!1;var a=this;if(this.labels={volume:{open:"Open Volume Controls",close:"Close Volume Controls"},pause:"Pause",play:"Play",download:"Download"},this.enableKeystrokes){window.addEventListener("keydown",this.pressKb.bind(a),!1),window.addEventListener("keyup",this.unPressKb.bind(a),!1),this.sliders[0].setAttribute("tabindex",0),this.sliders[1].setAttribute("tabindex",0),this.download.setAttribute("tabindex",-1),this.downloadLink.setAttribute("tabindex",-1);for(var n=0;n<this.svg.length;n++)this.svg[n].setAttribute("tabindex",0),this.svg[n].setAttribute("focusable",!0);for(var l=0;l<this.img.length;l++)this.img[l].setAttribute("tabindex",0)}else for(var r=0;r<this.span.length;r++)this.span[r].outerHTML="";if(this.showTooltips&&(this.playPauseBtn.setAttribute("title",this.labels.play),this.volumeBtn.setAttribute("title",this.labels.volume.open),this.downloadLink.setAttribute("title",this.labels.download)),i.outlineControls&&this.audioPlayer.classList.add("player-accessible"),i.showDownloadButton&&this.showDownload(),this.initEvents(),this.directionAware(),this.overcomeIosLimitations(),"autoplay"in this.player.attributes){var o=this.player.play();void 0!==o&&o.then(function(){a.player.parentElement.querySelector(".play-pause-btn__icon").attributes.d.value="M0 0h6v24H0zM12 0h6v24h-6z",a.playPauseBtn.setAttribute("aria-label",a.labels.pause),a.hasSetAttribute(a.playPauseBtn,"title",a.labels.pause)}).catch(function(){console.error("Green Audio Player Error: Autoplay has been prevented, because it is not allowed by this browser.")})}"preload"in this.player.attributes&&"none"===this.player.attributes.preload.value&&(this.playPauseBtn.style.visibility="visible",this.loading.style.visibility="hidden")}var e,t,i;return e=u,i=[{key:"init",value:function(t){document.querySelectorAll(t.selector).forEach(function(e){new u(e,t)})}},{key:"getTemplate",value:function(){return'\n            <div class="holder">\n                <div class="loading">\n                    <div class="loading__spinner"></div>\n                </div>\n\n                <div class="play-pause-btn" aria-label="Play" role="button">\n                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24">\n                        <path fill="#566574" fill-rule="evenodd" d="M18 12L0 24V0" class="play-pause-btn__icon"/>\n                    </svg>\n                </div>\n            </div>\n\n            <div class="controls">\n                <span class="controls__current-time" aria-live="off" role="timer">00:00</span>\n                <div class="controls__slider slider" data-direction="horizontal">\n                    <div class="controls__progress gap-progress" aria-label="Time Slider" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" role="slider">\n                        <div class="pin progress__pin" data-method="rewind"></div>\n                    </div>\n                </div>\n                <span class="controls__total-time">00:00</span>\n            </div>\n\n            <div class="volume">\n                <div class="volume__button" aria-label="Open Volume Controls" role="button">\n                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n                        <path class="volume__speaker" fill="#566574" fill-rule="evenodd" d="M14.667 0v2.747c3.853 1.146 6.666 4.72 6.666 8.946 0 4.227-2.813 7.787-6.666 8.934v2.76C20 22.173 24 17.4 24 11.693 24 5.987 20 1.213 14.667 0zM18 11.693c0-2.36-1.333-4.386-3.333-5.373v10.707c2-.947 3.333-2.987 3.333-5.334zm-18-4v8h5.333L12 22.36V1.027L5.333 7.693H0z"/>\n                    </svg>\n                    <span class="message__offscreen">Press Enter or Space to show volume slider.</span>\n                </div>\n                <div class="volume__controls hidden">\n                    <div class="volume__slider slider" data-direction="vertical">\n                        <div class="volume__progress gap-progress" aria-label="Volume Slider" aria-valuemin="0" aria-valuemax="100" aria-valuenow="81" role="slider">\n                            <div class="pin volume__pin" data-method="changeVolume"></div>\n                        </div>\n                        <span class="message__offscreen">Use Up/Down Arrow keys to increase or decrease volume.</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class="download">\n                <a class="download__link" href="" download="" aria-label="Download" role="button">\n                    <svg width="24" height="24" fill="#566574" enable-background="new 0 0 29.978 29.978" version="1.1" viewBox="0 0 29.978 29.978" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">\n                        <path d="m25.462 19.105v6.848h-20.947v-6.848h-4.026v8.861c0 1.111 0.9 2.012 2.016 2.012h24.967c1.115 0 2.016-0.9 2.016-2.012v-8.861h-4.026z"/>\n                        <path d="m14.62 18.426l-5.764-6.965s-0.877-0.828 0.074-0.828 3.248 0 3.248 0 0-0.557 0-1.416v-8.723s-0.129-0.494 0.615-0.494h4.572c0.536 0 0.524 0.416 0.524 0.416v8.742 1.266s1.842 0 2.998 0c1.154 0 0.285 0.867 0.285 0.867s-4.904 6.51-5.588 7.193c-0.492 0.495-0.964-0.058-0.964-0.058z"/>\n                    </svg>\n                </a>\n            </div>\n        '}},{key:"formatTime",value:function(e){var t=Math.floor(e/60),i=Math.floor(e%60);return"".concat(t<10?"0".concat(t):t,":").concat(i<10?"0".concat(i):i)}},{key:"pausePlayer",value:function(e){e.parentElement.querySelector(".play-pause-btn__icon").attributes.d.value="M18 12L0 24V0",e.pause()}},{key:"playPlayer",value:function(e){e.parentElement.querySelector(".play-pause-btn__icon").attributes.d.value="M0 0h6v24H0zM12 0h6v24h-6z",e.play()}},{key:"stopOtherPlayers",value:function(){for(var e=document.querySelectorAll(".green-audio-player audio"),t=0;t<e.length;t++)u.pausePlayer(e[t])}}],(t=[{key:"initEvents",value:function(){var a=this;a.audioPlayer.addEventListener("mousedown",function(e){if(a.isDraggable(e.target)){a.currentlyDragged=e.target;var t=a.currentlyDragged.dataset.method,i=a[t].bind(a);window.addEventListener("mousemove",i,!1),a.currentlyDragged.parentElement.parentElement===a.sliders[0]&&(a.paused=a.player.paused,!1===a.paused&&a.togglePlay()),window.addEventListener("mouseup",function(){!1!==a.currentlyDragged&&a.currentlyDragged.parentElement.parentElement===a.sliders[0]&&a.paused!==a.player.paused&&a.togglePlay(),a.currentlyDragged=!1,window.removeEventListener("mousemove",i,!1)},!1)}}),a.audioPlayer.addEventListener("touchstart",function(e){if(a.isDraggable(e.target)){var t=n(e.targetTouches,1);a.currentlyDragged=t[0];var i=a.currentlyDragged.target.dataset.method,s=a[i].bind(a);window.addEventListener("touchmove",s,!1),a.currentlyDragged.parentElement.parentElement===a.sliders[0]&&(a.paused=a.player.paused,!1===a.paused&&a.togglePlay()),window.addEventListener("touchend",function(){!1!==a.currentlyDragged&&a.currentlyDragged.parentElement.parentElement===a.sliders[0]&&a.paused!==a.player.paused&&a.togglePlay(),a.currentlyDragged=!1,window.removeEventListener("touchmove",s,!1)},!1),e.preventDefault()}}),this.playPauseBtn.addEventListener("click",this.togglePlay.bind(a)),this.player.addEventListener("timeupdate",this.updateProgress.bind(a)),this.player.addEventListener("volumechange",this.updateVolume.bind(a)),this.player.volume=.81,this.player.addEventListener("loadedmetadata",function(){a.totalTime.textContent=u.formatTime(a.player.duration)}),this.player.addEventListener("seeking",this.showLoadingIndicator.bind(a)),this.player.addEventListener("seeked",this.hideLoadingIndicator.bind(a)),this.player.addEventListener("canplay",this.hideLoadingIndicator.bind(a)),this.player.addEventListener("ended",function(){u.pausePlayer(a.player,"ended"),a.player.currentTime=0,a.playPauseBtn.setAttribute("aria-label",a.labels.play),a.hasSetAttribute(a.playPauseBtn,"title",a.labels.play)}),this.volumeBtn.addEventListener("click",this.showHideVolume.bind(a)),window.addEventListener("resize",a.directionAware.bind(a)),window.addEventListener("scroll",a.directionAware.bind(a));for(var e=0;e<this.sliders.length;e++){var t=this.sliders[e].querySelector(".pin");this.sliders[e].addEventListener("click",a[t.dataset.method].bind(a))}this.downloadLink.addEventListener("click",this.downloadAudio.bind(a))}},{key:"overcomeIosLimitations",value:function(){this.isDevice&&(this.player.addEventListener("loadedmetadata",this.hideLoadingIndicator.bind(this)),this.audioPlayer.querySelector(".volume").style.display="none",this.audioPlayer.querySelector(".controls").style.marginRight="0")}},{key:"isDraggable",value:function(e){var t=!1;if(void 0===e.classList)return!1;for(var i=0;i<this.draggableClasses.length;i++)e.classList.contains(this.draggableClasses[i])&&(t=!0);return t}},{key:"inRange",value:function(e){var t="touches"in e,i=this.getRangeBox(e),s=i.getBoundingClientRect(),a=null,n=null;if("horizontal"===i.dataset.direction){n=(a=s.x)+s.width;var l=t?e.touches[0].clientX:e.clientX;if(l<a||n<l)return!1}else{n=(a=s.top)+s.height;var r=t?e.touches[0].clientY:e.clientY;if(r<a||n<r)return!1}return!0}},{key:"updateProgress",value:function(){var e=this.player.currentTime,t=e/this.player.duration*100;this.progress.setAttribute("aria-valuenow",t),this.progress.style.width="".concat(t,"%"),this.currentTime.textContent=u.formatTime(e)}},{key:"updateVolume",value:function(){this.volumeProgress.setAttribute("aria-valuenow",100*this.player.volume),this.volumeProgress.style.height="".concat(100*this.player.volume,"%"),.5<=this.player.volume?this.speaker.attributes.d.value="M14.667 0v2.747c3.853 1.146 6.666 4.72 6.666 8.946 0 4.227-2.813 7.787-6.666 8.934v2.76C20 22.173 24 17.4 24 11.693 24 5.987 20 1.213 14.667 0zM18 11.693c0-2.36-1.333-4.386-3.333-5.373v10.707c2-.947 3.333-2.987 3.333-5.334zm-18-4v8h5.333L12 22.36V1.027L5.333 7.693H0z":this.player.volume<.5&&.05<this.player.volume?this.speaker.attributes.d.value="M0 7.667v8h5.333L12 22.333V1L5.333 7.667M17.333 11.373C17.333 9.013 16 6.987 14 6v10.707c2-.947 3.333-2.987 3.333-5.334z":this.player.volume<=.05&&(this.speaker.attributes.d.value="M0 7.667v8h5.333L12 22.333V1L5.333 7.667")}},{key:"getRangeBox",value:function(e){var t=e.target,i=this.currentlyDragged;return"click"===e.type&&this.isDraggable(e.target)&&(t=e.target.parentElement.parentElement),"mousemove"===e.type&&(t=i.parentElement.parentElement),"touchmove"===e.type&&(t=i.target.parentElement.parentElement),t}},{key:"getCoefficient",value:function(e){var t="touches"in e,i=this.getRangeBox(e),s=i.getBoundingClientRect(),a=0;if("horizontal"===i.dataset.direction)a=((t?e.touches[0].clientX:e.clientX)-s.left)/s.width;else if("vertical"===i.dataset.direction){var n=s.height;a=1-((t?e.touches[0].clientY:e.clientY)-s.top)/n}return a}},{key:"rewind",value:function(e){this.player.seekable&&this.player.seekable.length&&this.inRange(e)&&(this.player.currentTime=this.player.duration*this.getCoefficient(e))}},{key:"showVolume",value:function(){this.volumeBtn.getAttribute("aria-attribute")===this.labels.volume.open&&(this.volumeControls.classList.remove("hidden"),this.volumeBtn.classList.add("open"),this.volumeBtn.setAttribute("aria-label",this.labels.volume.close),this.hasSetAttribute(this.volumeBtn,"title",this.labels.volume.close))}},{key:"showHideVolume",value:function(){this.volumeControls.classList.toggle("hidden"),this.volumeBtn.getAttribute("aria-label")===this.labels.volume.open?(this.volumeBtn.setAttribute("aria-label",this.labels.volume.close),this.hasSetAttribute(this.volumeBtn,"title",this.labels.volume.close),this.volumeBtn.classList.add("open")):(this.volumeBtn.setAttribute("aria-label",this.labels.volume.open),this.hasSetAttribute(this.volumeBtn,"title",this.labels.volume.open),this.volumeBtn.classList.remove("open"))}},{key:"changeVolume",value:function(e){this.inRange(e)&&(this.player.volume=Math.round(50*this.getCoefficient(e))/50)}},{key:"preloadNone",value:function(){this.player.duration||(this.playPauseBtn.style.visibility="hidden",this.loading.style.visibility="visible")}},{key:"togglePlay",value:function(){this.preloadNone(),this.player.paused?(this.stopOthersOnPlay&&u.stopOtherPlayers(),u.playPlayer(this.player),this.playPauseBtn.setAttribute("aria-label",this.labels.pause),this.hasSetAttribute(this.playPauseBtn,"title",this.labels.pause)):(u.pausePlayer(this.player,"toggle"),this.playPauseBtn.setAttribute("aria-label",this.labels.play),this.hasSetAttribute(this.playPauseBtn,"title",this.labels.play))}},{key:"hasSetAttribute",value:function(e,t,i){this.showTooltips&&e.hasAttribute(t)&&e.setAttribute(t,i)}},{key:"setCurrentTime",value:function(e){var t=this.player.currentTime,i=Math.floor(this.player.duration);t+e<0&&0===t?this.player.currentTime=this.player.currentTime:t+e<0?this.player.currentTime=0:i<t+e?this.player.currentTime=i:this.player.currentTime+=e}},{key:"setVolume",value:function(e){if(!this.isDevice){var t=this.player.volume;0<=t+e&&t+e<1?this.player.volume+=e:this.player.volume=t+e<=0?0:1}}},{key:"unPressKb",value:function(e){var t=e||window.event;!this.seeking||37!==t.keyCode&&39!==t.keyCode||(this.togglePlay(),this.seeking=!1)}},{key:"pressKb",value:function(e){var t=e||window.event;switch(t.keyCode){case 13:case 32:if(document.activeElement.parentNode===this.playPauseBtn)this.togglePlay();else if(document.activeElement.parentNode===this.volumeBtn||document.activeElement===this.sliders[1]){if(document.activeElement===this.sliders[1])try{this.volumeBtn.children[0].focus()}catch(e){this.volumeBtn.focus()}this.showHideVolume()}13===t.keyCode&&this.showDownload&&document.activeElement.parentNode===this.downloadLink&&this.downloadLink.focus();break;case 37:case 39:document.activeElement===this.sliders[0]&&(37===t.keyCode?this.setCurrentTime(-5):this.setCurrentTime(5),!this.player.paused&&this.player.seeking&&(this.togglePlay(),this.seeking=!0));break;case 38:case 40:document.activeElement.parentNode!==this.volumeBtn&&document.activeElement!==this.sliders[1]||(38===t.keyCode?this.setVolume(.05):this.setVolume(-.05)),document.activeElement.parentNode===this.volumeBtn&&this.showVolume()}}},{key:"showLoadingIndicator",value:function(){this.playPauseBtn.style.visibility="hidden",this.loading.style.visibility="visible"}},{key:"hideLoadingIndicator",value:function(){this.playPauseBtn.style.visibility="visible",this.loading.style.visibility="hidden"}},{key:"showDownload",value:function(){this.download.style.display="block"}},{key:"downloadAudio",value:function(){var e=this.player.currentSrc,t=e.split("/").reverse()[0];this.downloadLink.setAttribute("href",e),this.downloadLink.setAttribute("download",t)}},{key:"directionAware",value:function(){this.volumeControls.classList.remove("top","middle","bottom"),window.innerHeight<250?this.volumeControls.classList.add("middle"):this.audioPlayer.getBoundingClientRect().top<180?this.volumeControls.classList.add("bottom"):this.volumeControls.classList.add("top")}}])&&s(e.prototype,t),i&&s(e,i),u}();i.default=a},{}]},{},[1])(1)});
/*! js-cookie v3.0.0 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      value = converter.write(value, key);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie = key + '=' + value + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        if (value[0] === '"') {
          value = value.slice(1, -1);
        }

        try {
          var foundKey = defaultConverter.read(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

(function($) {
    /**
     * Menu script
     */
    class BMW_Menu {
      constructor() {
        this.initState();
        this.initEvents();
      }
    
      initState() {
        this.win = $(window);
        this.menuWrapper = $('.page-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menu = this.menuWrapper.find('.menu');
        this.menuItem = this.menu.find('.menu-item');
      }
    
      initEvents() {
        if (this.menuIcon.length) {
          this.menuIcon.on('click', e => {
            e.preventDefault();
            this.menu.toggleClass('is-active');
            this.menuIcon.toggleClass('is-active');
            this.menu.find('.menu-item').first().find('.menu-item-link').focus();
            $(document.body).toggleClass('no-scroll');
    
            setTimeout(() => {
              this.menu.toggleClass('is-showing');
            }, 150);
          });
        }
    
        if (this.menuItem.length) {
          this.menuItem.on('click', e => {
            this.menu.removeClass('is-active');
            this.menu.removeClass('is-showing');
            this.menuIcon.removeClass('is-active');
            $(document.body).removeClass('no-scroll');
          });
        }
      }
    }
    
    /**
     * Tabs script
     */
    class BMW_Tabs {
      constructor() {
        this.initState();
        this.initEvents();
      }
    
      initState() {
        this.tablinksWrapper = document.querySelectorAll('.tabs__tablinks');
      }
    
      initEvents() {
        if (!this.tablinksWrapper) {
          return;
        }
    
        for (let i = 0; i < this.tablinksWrapper.length; i++) {
          if (!this.tablinksWrapper[i].getAttribute('data-js-initialized')) {
            this.tablinksWrapper[i].setAttribute('data-js-initialized', true);
            let tablinks = this.tablinksWrapper[i].querySelectorAll('.tabs__tablinks-item');
    
            for (let j = 0; j < tablinks.length; j++) {
              tablinks[j].addEventListener('click', this.showTab.bind(this));
            }
          }
        }
      }
    
      showTab(e) {
        let tabID = e.target.getAttribute('data-id');
        let wrapper = e.target.parentNode.parentNode;
        let wrapperID = e.target.parentNode.parentNode.getAttribute('data-tablinks');
        let tabContent = wrapper.querySelector('.tabs__content[data-id="' + tabID + '"]');
        let tabs = wrapper.querySelectorAll('.tabs__tablinks-item');
        let content = wrapper.querySelectorAll('.tabs__content');
    
        if (tabID) {
          tabID = tabID.replace(/[^a-z0-9\-]/gmi, '');
        }
    
        if (wrapperID) {
          wrapperID = wrapperID.replace(/[^a-z0-9\-]/gmi, '');
        }
    
        for (let i = 0; i < tabs.length; i++) {
          tabs[i].classList.remove('tabs__tablinks-item--active');
          content[i].classList.remove('tabs__content--showing');
          content[i].classList.remove('tabs__content--active');
          content[i].setAttribute('data-current-item', '0');
          if (content[i].querySelector('.product-slider__list')) {
            content[i].querySelector('.product-slider__list').style.marginLeft = '0%';
          }
          if (content[i].querySelector('.prev')) {
            content[i].querySelector('.prev').classList.add('is-disabled');
          }
        }
    
        e.target.classList.add('tabs__tablinks-item--active');
        tabContent.classList.add('tabs__content--active');
    
        setTimeout(() => {
          tabContent.classList.add('tabs__content--showing');
        }, 200);
      }
    }
    class BMW_FormHelper {
      constructor (formElement) {
        this.formElement = formElement;
        this.rules = {
          required: {
            validator: (value, field) => {
              if (field.attr('type') === 'checkbox') {
                return field.prop('checked');
              }
    
              if (field.attr('type') === 'radio') {
                let selectedValueExists = field.parents('.form-item').find('input[type="radio"]:checked').length;
                return !!selectedValueExists;
              }
    
              if (field.attr('type') === 'file') {
                let selectedFileExists = field[0].files.length;
                return !!selectedFileExists;
              }
    
              return !!value;
            },
            errorText: 'Pole jest wymagane'
          },
          requiredIfDateToVisible: {
            validator: (value, field) => {
              let dateToField = field.parents('form').find('[data-fh-name="date_to"]');
    
              if (dateToField.length && dateToField.hasClass('is-hidden')) {
                return true;
              }
    
              return !!value;
            },
            errorText: 'Pole jest wymagane'
          },
          min: {
            validator: (value, range) => parseFloat(value) >= parseFloat(range),
            errorText: (range) => 'Wartość nie może być mniejsza niż ' + range
          },
          max: {
            validator: (value, range) => parseFloat(value) <= parseFloat(range),
            errorText: (range) => 'Wartość nie może być większa niż ' + range
          },
          email: {
            validator: (value) => value.indexOf('@') > 0 && value.indexOf('.') > -1,
            errorText: 'Podaj prawidłowy adres e-mail'
          },
          postcode: {
            validator: (value) => typeof value === "string" && (new RegExp(/^[0-9]{2,2}\-[0-9]{3,3}$/gmi).test(value) || new RegExp(/^[0-9]{5,5}$/gmi).test(value)),
            errorText: 'Kod pocztowy musi być podany w formacie XX-XXX lub XXXXX'
          }
        };	
        this.dependencies = {};	
      }
    
      formDependencies (config) {
        for (let i = 0; i < config.length; i++) {
          if (config[i].useCollection) {
            let triggerSelector = config[i].dependsOn;
            let fieldName = config[i].field.replace(/[^a-z0-9\_\-]/gmi, '');
            let callback = config[i].elementsToShow;
            let triggerElement = this.formElement.find(triggerSelector);
            let fieldElements = this.formElement.find('*[data-fh-name="' + fieldName + '"]');
    
            triggerElement.on('input', (e) => {
              fieldElements.addClass('is-hidden');
              
              for (let j = 0; j < fieldElements.length; j++) {
                this.resetField(fieldElements.eq(j));
              }
    
              let elementsToShow = callback($(e.target).val());
              elementsToShow.removeClass('is-hidden');
            });
          } else {
            let triggerSelector = config[i].dependsOn;
            let fieldName = config[i].field.replace(/[^a-z0-9\_\-]/gmi, '');
            let callback = config[i].showOn;
            let triggerElement = this.formElement.find(triggerSelector);
            let fieldElement = this.formElement.find('*[data-fh-name="' + fieldName + '"]');
    
            triggerElement.on('input', (e) => {
              if (callback($(e.target).val())) {
                fieldElement.removeClass('is-hidden');
              } else {
                fieldElement.addClass('is-hidden');
                this.resetField(fieldElement);
              }
            });
          }
        }
      }
    
      resetField (fieldWrapper) {
        if (fieldWrapper.find('input').length) {
          if (fieldWrapper.find('input').attr('type') === 'radio') {
            fieldWrapper.find('input').prop('checked', false);
          } else {
            fieldWrapper.find('input').val('');
          }
    
          fieldWrapper.find('input').trigger('input');
        } else if (fieldWrapper.find('select').length) {
          fieldWrapper.find('select').val('');
          fieldWrapper.find('select').trigger('input');
        } else if (fieldWrapper.find('textarea').length) {
          fieldWrapper.find('textarea').val('');
          fieldWrapper.find('textarea').trigger('input');
        }
      }
    
      formValidate () {
        // pobieramy wszystkie pole
        let fields = this.formElement.find('*[data-fh-validation]');
        let formIsValid = true;
        
        for (let i = 0; i < fields.length; i++) {
          // pomijamy ukryte pola
          if (fields.eq(i).parents('[data-fh-name]').hasClass('is-hidden')) {
            continue;
          }
    
          let fieldValue = fields.eq(i).val();
          let validationRules = fields.eq(i).attr('data-fh-validation');
          validationRules = validationRules.split('|');
          let fieldIsValid = true;
          let fieldErrorMessage = fields.eq(i).parents('.form-item').find('.validation-error');
    
          for (let j = 0; j < validationRules.length; j++) {
            let validationRule = validationRules[j];
    
            if (validationRule.indexOf(':') > -1) {
              let ruleName = validationRule.split(':')[0];
              let range = validationRule.split(':')[1];
    
              if (!this.rules[ruleName].validator(fieldValue, range)) {
                fieldIsValid = false;
                fieldErrorMessage.text(this.rules[ruleName].errorText(range));
                break;
              }
            } else {
              if (!this.rules[validationRule].validator(fieldValue, fields.eq(i))) {
                fieldIsValid = false;
                fieldErrorMessage.text(this.rules[validationRule].errorText);
                break;
              } 
            }
          }
    
          if (fieldIsValid) {
            fieldErrorMessage.addClass('is-hidden');
            fieldErrorMessage.text('');
          } else {
            formIsValid = false;
            fieldErrorMessage.removeClass('is-hidden');
            fields.eq(i).one('input', () => {
              fieldErrorMessage.addClass('is-hidden');
              fieldErrorMessage.text('');
            });
          }
        }
    
        return formIsValid;
      }
    }
    /**
     * Contest Form script
     */
     class BMW_ContestForm {
      constructor() {
        this.initState();
      }
    
      initState() {
        this.contestFormWrapper = $('.js-contest-form');
    
        if (this.contestFormWrapper.length) {
          this.initContestForm();
        }
      }
    
      initContestForm () {
        this.submitForm = this.contestFormWrapper.find('input[type="submit"]');
        this.contestForm = this.contestFormWrapper.find('.contest-form');
    
        let formHelper = new BMW_FormHelper(this.contestForm);
    
        $('#picture-to-upload').on('change', function(e) {
          let thisInputFile = $(e.target);
          const size = (this.files[0].size / 1024 / 1024).toFixed(2);
    
          if (size > 5) {
            alert('Plik nie może ważyć więcej niż 5 MB');
            thisInputFile.val('');
          }
        });
    
        $('#sound-to-upload').on('change', function(e) {
          let thisInputFile = $(e.target);
          const size = (this.files[0].size / 1024 / 1024).toFixed(2);
    
          if (size > 15) {
            alert('Plik nie może ważyć więcej niż 15 MB');
            thisInputFile.val('');
          }
        });
    
        $('#move-to-upload').on('change', function(e) {
          let thisInputFile = $(e.target);
          const size = (this.files[0].size / 1024 / 1024).toFixed(2);
    
          if (size > 15) {
            alert('Plik nie może ważyć więcej niż 15 MB');
            thisInputFile.val('');
          }
        });
    
        this.submitForm.on('click', e => {
          e.preventDefault();
    			let result = formHelper.formValidate();
    
    			if (result) {
            this.contestForm.addClass('is-loading');
    
            setTimeout(() => {
                let form = this.contestFormWrapper.find('.contest-form');
                let categoryEvent = $('input[name="data[contest_type]"]').attr('value');
                form.find('.form-contest-success').addClass('is-hidden');
                form.find('.form-contest-fail').addClass('is-hidden');
    
                $.ajax({
                  type: 'POST',
                  url: form.attr('action'),
                  processData: false,
                  contentType: false,
                  data: new FormData(form[0]),
                }).done((data) => {
                  if (data.success) {
                    form.find('.form-contest-success').removeClass('is-hidden');
                    form.find('input[type="submit"]').addClass('is-hidden');
                    
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                      'event': 'formSent',
                      'category': categoryEvent
                    });
                  } else if (data.errors) {
                    let output = [];
                    let errorFields = Object.keys(data.errors);
    
                    for (let i = 0; i < errorFields.length; i++) {
                      let field = errorFields[i];
                      if (data.errors[field].length) {
                        output.push(data.errors[field][0]);
                      }
                    }
    
                    output = output.join("<br />");
    
                    form.find('.form-contest-error span').html(output);
                    form.find('.form-contest-error').removeClass('is-hidden');
                  } else {
                    form.find('.form-contest-fail').removeClass('is-hidden');
                  }
                }).fail((data) => {
                  if (data.responseJSON && data.responseJSON.errors) {
                    let output = [];
                    let errorFields = Object.keys(data.responseJSON.errors);
    
                    for (let i = 0; i < errorFields.length; i++) {
                      let field = errorFields[i];
                      if (data.responseJSON.errors[field].length) {
                        output.push(data.responseJSON.errors[field][0]);
                      }
                    }
    
                    output = output.join("<br />");
                    form.find('.form-contest-error span').html(output);
                    form.find('.form-contest-error').removeClass('is-hidden');
                  } else {
                    form.find('.form-contest-fail').removeClass('is-hidden');
                  }
                }).always(() => {
                  this.contestForm.removeClass('is-loading');
                });
            }, 1000);
    			}
        });
      }
    }
    
    /**
     * Vote Form script
     */
     class BMW_VoteForm {
      constructor() {
        this.initState();
        this.initAudioPlayers();
      }
    
      initState() {
        if (!$('.vote-form').length) {
          return
        }
    
        $('.vote-forms-wrapper').on('click', e => {
          if (e.target.tagName === 'INPUT' && e.target.getAttribute('class').indexOf('btn-vote-form-submit') > -1) {
            e.preventDefault();
            let formWrapper = $(e.target.parentNode);
            this.submitForm(formWrapper);
          }
        });
    
        this.loadMoreBtn = $('#load-more-items');
        this.itemsList = $('.vote-forms-list');
    
        if (this.loadMoreBtn.length) {
          this.loadMoreBtn.on('click', e => {
            e.preventDefault();
            this.loadMoreItems();
          });
        }
      }
    
      initAudioPlayers () {
        if (!$('.audio-player').length) {
          return;
        }
    
        GreenAudioPlayer.init({
          selector: '.audio-player:not([data-green-audio-player-is-initialized="true"])',
          stopOthersOnPlay: true
        });
    
        $('.audio-player:not([data-green-audio-player-is-initialized="true"])').each((i, playerInstance) => {
          $(playerInstance).attr('data-green-audio-player-is-initialized', 'true');
        });
      }
    
      submitForm (wrapper) {
        wrapper.addClass('is-loading');
    
        setTimeout(() => {
          wrapper.find('.form-contest-success').addClass('is-hidden');
          wrapper.find('.form-contest-fail').addClass('is-hidden');
          wrapper.find('.form-contest-error').addClass('is-hidden');
    
          $.ajax({
            type: 'POST',
            url: wrapper.attr('action'),
            processData: false,
            contentType: false,
            data: new FormData(wrapper[0]),
          }).done((data) => {
            if (data.success) {
              wrapper.find('.form-contest-success').removeClass('is-hidden');
              wrapper.find('input[type="submit"]').addClass('is-hidden');
            } else if (data.error) {
              wrapper.find('.form-contest-error span').text(data.responseJSON.error);
              wrapper.find('.form-contest-error').removeClass('is-hidden');
              wrapper.find('input[type="submit"]').addClass('is-hidden');
            } else {
              wrapper.find('.form-contest-fail').removeClass('is-hidden');
              wrapper.find('input[type="submit"]').addClass('is-hidden')
            }
          }).fail((data) => {
            if (data.responseJSON && data.responseJSON.error) {
              wrapper.find('.form-contest-error span').text(data.responseJSON.error);
              wrapper.find('.form-contest-error').removeClass('is-hidden');
              wrapper.find('input[type="submit"]').addClass('is-hidden');
            } else {
              wrapper.find('.form-contest-fail').removeClass('is-hidden');
              wrapper.find('input[type="submit"]').addClass('is-hidden')
            }
          }).always(() => {
            wrapper.removeClass('is-loading');
          });
        }, 1000);
      }
    
      loadMoreItems () {
        this.loadMoreBtn.addClass('is-loading');
        let initialOffset = parseInt(this.loadMoreBtn.attr('data-initial-offset'), 10);
        let currentPage = parseInt(this.loadMoreBtn.attr('data-current-page'), 10);
        let itemsPerPage = 12;
        let offset = initialOffset + ((currentPage - 1) * itemsPerPage);
        let maxItems = parseInt(this.loadMoreBtn.attr('data-count'), 10);
        let contestType = this.loadMoreBtn.attr('data-contest-type');
    
        if (offset > maxItems) {
          return false;
        }
    
        $.ajax({
          type: 'POST',
          url: this.loadMoreBtn.attr('data-endpoint'),
          data: {
            _token: $('meta[name="_token"]').attr('content'),
            contest_id: parseInt(this.loadMoreBtn.attr('data-contest-id'), 10),
            offset: offset
          }
        }).done((data) => {
          currentPage++;
          this.loadMoreBtn.attr('data-current-page', currentPage);
    
          if (data.end) {
            this.loadMoreBtn.remove();
          }
    
          if (data.items && data.items.length) {
            for (let i = 0; i < data.items.length; i++) {
              this.renderItem(data.items[i], contestType);
            }
          }
    
          setTimeout(() => {
            this.initAudioPlayers();
          }, 0);
        }).always(() => {
          this.loadMoreBtn.removeClass('is-loading');
        });
      }
    
      renderItem (itemData, type) {
        let template = '';
    
        if (type === 'picture') {
          template = `
          <form
            id="submission-${parseInt(itemData.id, 10)}"
            class="vote-form picture"
            method="post"
            action="${itemData.voteUrl}">
            <input type="hidden" name="_token" value="${itemData.token}">
            <input type="hidden" name="submission_id" value="${parseInt(itemData.id, 10)}" required>
            <span class="submission-title">${itemData.name}</span>
            <div class="image">
              <img src="${itemData.itemUrl}" alt="" loading="lazy">
            </div>
            <input type="submit" value="Zagłosuj" class="btn btn-dark btn-vote-form-submit">
            <button type="button" onclick="copyLink('link-to-${itemData.id}')" class="btn btn-dark btn-copy">Skopiuj link</button>
            <p id="link-to-${itemData.id}-copied" class="link-copied" style="display: none;">Link został skopiowany!</p>
            <p id="link-to-${itemData.id}" style="display: none">https://bmwkreatywnejazdy.pl/konkurs/zgloszenie/${itemData.id}</p>
            <div class="form-contest-success is-hidden">
                Zagłosowano!
            </div>
            <div class="form-contest-fail is-hidden">
                Wystąpił błąd
            </div>
            <div class="form-contest-error is-hidden">
                Nie możesz głosować ponownie
            </div>
          </form>
          `;
        } else if (type === 'move') {
          template = `
          <form
            id="submission-${parseInt(itemData.id, 10)}"
            class="vote-form move"
            method="post"
            action="${itemData.voteUrl}">
            <input type="hidden" name="_token" value="${itemData.token}">
            <input type="hidden" name="submission_id" value="${parseInt(itemData.id, 10)}" required>
            <span class="submission-title">${itemData.name}</span>
            <div class="movie">
                <video width="80%" height="300" controls>
                  <source src="${itemData.itemUrl}">
                </video>
            </div>
            <input type="submit" value="Zagłosuj" class="btn btn-dark btn-vote-form-submit">
            <button type="button" onclick="copyLink('link-to-${itemData.id}')" class="btn btn-dark btn-copy">Skopiuj link</button>
            <p id="link-to-${itemData.id}-copied" class="link-copied" style="display: none;">Link został skopiowany!</p>
            <p id="link-to-${itemData.id}" style="display: none">https://bmwkreatywnejazdy.pl/konkurs/zgloszenie/${itemData.id}</p>
            <div class="form-contest-success is-hidden">
              Zagłosowano!
            </div>
            <div class="form-contest-fail is-hidden">
              Wystąpił błąd
            </div>
            <div class="form-contest-error is-hidden">
              Nie możesz głosować ponownie
            </div>
          </form>
          `;
        } else if (type === 'sound') {
          template = `
          <form
            id="submission-${parseInt(itemData.id, 10)}"
            class="vote-form sound"
            method="post"
            action="${itemData.voteUrl}">
            <input type="hidden" name="_token" value="${itemData.token}">
            <input type="hidden" name="submission_id" value="${parseInt(itemData.id, 10)}" required>
            <div class="audio">
                <span class="submission-title">${itemData.name}</span>
                <div class="audio-player">
                  <audio>
                    <source src="${itemData.itemUrl}">
                    Your browser does not support the audio element.
                  </audio>
                </div>
            </div>
            <input type="submit" value="Zagłosuj" class="btn btn-dark btn-vote-form-submit">
            <button type="button" onclick="copyLink('link-to-${itemData.id}')" class="btn btn-dark btn-copy">Skopiuj link</button>
            <p id="link-to-${itemData.id}-copied" class="link-copied" style="display: none;">Link został skopiowany!</p>
            <p id="link-to-${itemData.id}" style="display: none">https://bmwkreatywnejazdy.pl/konkurs/zgloszenie/${itemData.id}</p>
            <div class="form-contest-success is-hidden">
              Zagłosowano!
            </div>
            <div class="form-contest-fail is-hidden">
              Wystąpił błąd
            </div>
            <div class="form-contest-error is-hidden">
              Nie możesz głosować ponownie
            </div>
          </form>
          `;
        }
    
        if (template) {
          $(template).appendTo(this.itemsList);
        }
      }
    }
    
    /**
     * UI elements
     */
    class BMW_UI {
      constructor() {
        this.initSmoothScroll();
        this.initOpenTabs();
        this.initYTVideoWithCover();
        this.initVideoWithCover();
        this.initConfirmationPopup();
        this.initExpandText();
        this.initCheckAllCookies();
      }
    
      initSmoothScroll () {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
          ) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
              event.preventDefault();
              $('html, body').animate({
                scrollTop: target.offset().top - 50
              }, 1000);
            }
          }
        });
      }
    
      initOpenTabs () {
        let menuOpenContest = $('a[data-id="contest"]');
        let menuOpenMasterclass = $('a[data-id="masterclass"]')
        let openContest = $('.show-contest');
        let openMasterclass = $('.show-masterclass');
        let tabs = $('.tabs');
        let tablinksContest = $('.tabs__tablinks-contest');
        let tablinksMasterclass = $('.tabs__tablinks-masterclass');
        let tabcontentContest = $('.tabs__content-contest');
        let tabcontentMasterclass = $('.tabs__content-masterclass');
    
        openContest.on('click', e => {
          e.preventDefault();
          $('.choose-section').css('display', 'none');
          tabs.addClass('is-active');
          tablinksContest.addClass('tabs__tablinks-item--active');
          tabcontentContest.addClass('tabs__content--active');
    
          tablinksMasterclass.removeClass('tabs__tablinks-item--active');
          tabcontentMasterclass.removeClass('tabs__content--active');
    
          setTimeout(() => {
            tabcontentContest.addClass('tabs__content--showing');
            tabcontentMasterclass.removeClass('tabs__content--showing');
          }, 200);
        });
    
        menuOpenContest.on('click', () => {
          $('.choose-section').css('display', 'none');
          tabs.addClass('is-active');
          tablinksContest.addClass('tabs__tablinks-item--active');
          tabcontentContest.addClass('tabs__content--active');
    
          tablinksMasterclass.removeClass('tabs__tablinks-item--active');
          tabcontentMasterclass.removeClass('tabs__content--active');
    
          setTimeout(() => {
            tabcontentContest.addClass('tabs__content--showing');
            tabcontentMasterclass.removeClass('tabs__content--showing');
          }, 200);
        });
    
        openMasterclass.on('click', e => {
          e.preventDefault();
          $('.choose-section').css('display', 'none');
          tabs.addClass('is-active');
          tablinksMasterclass.addClass('tabs__tablinks-item--active');
          tabcontentMasterclass.addClass('tabs__content--active');
    
          tablinksContest.removeClass('tabs__tablinks-item--active');
          tabcontentContest.removeClass('tabs__content--active');
    
          setTimeout(() => {
            tabcontentMasterclass.addClass('tabs__content--showing');
            tabcontentContest.removeClass('tabs__content--showing');
          }, 200);
        });
    
        menuOpenMasterclass.on('click', () => {
          $('.choose-section').css('display', 'none');
          tabs.addClass('is-active');
          tablinksMasterclass.addClass('tabs__tablinks-item--active');
          tabcontentMasterclass.addClass('tabs__content--active');
    
          tablinksContest.removeClass('tabs__tablinks-item--active');
          tabcontentContest.removeClass('tabs__content--active');
    
          setTimeout(() => {
            tabcontentMasterclass.addClass('tabs__content--showing');
            tabcontentContest.removeClass('tabs__content--showing');
          }, 200);
        });
    
        if(window.location.hash == "#contest-block") {
          $('.choose-section').css('display', 'none');
          tabs.addClass('is-active');
          tablinksContest.addClass('tabs__tablinks-item--active');
          tabcontentContest.addClass('tabs__content--active');
    
          tablinksMasterclass.removeClass('tabs__tablinks-item--active');
          tabcontentMasterclass.removeClass('tabs__content--active');
    
          setTimeout(() => {
            tabcontentContest.addClass('tabs__content--showing');
            tabcontentMasterclass.removeClass('tabs__content--showing');
          }, 200);
        }
    
        if(window.location.hash == "#masterclass-block") {
          $('.choose-section').css('display', 'none');
          tabs.addClass('is-active');
          tablinksMasterclass.addClass('tabs__tablinks-item--active');
          tabcontentMasterclass.addClass('tabs__content--active');
    
          tablinksContest.removeClass('tabs__tablinks-item--active');
          tabcontentContest.removeClass('tabs__content--active');
    
          setTimeout(() => {
            tabcontentMasterclass.addClass('tabs__content--showing');
            tabcontentContest.removeClass('tabs__content--showing');
          }, 200);
        };
      }
    
      initYTVideoWithCover () {
        let videos = $('.video-wrapper .overlay');
    
        if (!videos.length) {
          return;
        }
    
        for (let i = 0; i < videos.length; i++) {
          let overlay = videos.eq(i);
          let downoladBtn = videos.eq(i).find('.btn');
    
          downoladBtn.on('click', e => {
            e.stopPropagation();
          });
    
          videos.eq(i).on('click', e => {
            e.preventDefault();
            overlay.addClass('is-hidden');
            let iframe = overlay.parent().find('iframe');
            
            iframe.on('load', function () {
              setTimeout(() => {
                iframe[0].contentWindow.postMessage(JSON.stringify({
                  'event': 'command',
                  'func': 'playVideo',
                  'args': []
                }), '*');
              }, 500);
            });
    
            iframe.attr('src', iframe.attr('data-lazyload-src'));
          });
        }
      }
    
      initVideoWithCover () {
        let videos = $('.video-wrapper .overlay.cover');
        
        if (!videos.length) {
          return;
        }
    
        for (let i = 0; i < videos.length; i++) {
          let overlay = videos.eq(i);
    
          overlay.click(function() {
            overlay.addClass('is-hidden');
            let video = overlay.parent().find('.video');
            video[0].play();
          });
        }
      }
    
      initConfirmationPopup () {
        if (!window.location.search || window.location.search.indexOf('popup_confirmed=') === -1) {
          return;
        }
    
        var urlQuery = window.location.search;
        urlQuery = urlQuery.replace('?', '');
        urlQuery = urlQuery.split('&');
    
        for (var i = 0; i < urlQuery.length; i++) {
          var keyPair = urlQuery[i].split('=');
    
          if (keyPair[0] === 'popup_confirmed') {
            var popupType = parseInt(keyPair[1], 10);
    
            if (popupType === 1 || popupType === 2 || popupType === 0) {
              showPopup(popupType);
              break;
            }
          }
        }
    
        function showPopup (popupType) {
          var popup = $('<div class="confirm-popup"><div class="confirm-popup-overlay"></div><div class="confirm-popup__inner"><a href="#close" class="confirm-popup-close">&times;</a><p class="confirm-popup-content-text"></p></div></div>');
          
          if (popupType === 1) {
            popup.find('.confirm-popup-content-text').text('Dziękujemy, twoje zgłoszenie zostało potwierdzone. Powodzenia!');
          } else if (popupType === 0) {
            popup.find('.confirm-popup-content-text').text('Wystąpił problem z potwierdzeniem zgłoszenia. Spróbuj póżniej lub skontaktuj sie z nami".');
          } else if (popupType === 2) {
            popup.find('.confirm-popup-content-text').text('Dziękujemy, twoje zgłoszenie już zostało potwierdzone.');
          }
    
          popup.appendTo(document.body);
          popup.find('.confirm-popup-close').on('click', function (e) {
            e.preventDefault();
            popup.remove();
          });
        }
      }
    
      initExpandText () {
        let expandText = document.querySelectorAll('.expand-text');
    
        for (let i = 0; i < expandText.length; i++) {
          if (!expandText[i].getAttribute('data-js-initialized')) {
            expandText[i].setAttribute('data-js-initialized', true);
    
            let expandLink = expandText[i].querySelector('.expand-text__link');
            let expandTextContent = expandText[i].querySelector('.expand-text__inner');
            let expandTextContentText = expandText[i].querySelector('.expand-text__inner > div');
    
            if (expandLink) {
              expandTextContent.style.height = 0 + 'px';
              expandLink.classList.remove('expand-text__link--open');
    
              expandLink.addEventListener('click', (e) => {
                e.preventDefault();
                expandTextContent.classList.toggle('expand-text__inner--expanded');
                let newHeight = expandTextContentText.offsetHeight;
    
                if (expandTextContent.classList.contains('expand-text__inner--expanded')) {
                  expandTextContent.style.height = 0 + 'px';
                  expandLink.classList.remove('expand-text__link--open');
                  expandLink.innerText = expandLink.getAttribute('data-text-less');
    
                  setTimeout(() => {
                    expandTextContent.style.height = (newHeight + 'px');
                    expandLink.classList.add('expand-text__link--open');
                  }, 0);
    
                  setTimeout(() => {
                    expandTextContent.style.height = 'auto';
                  }, 500);
                } else {
                  expandTextContent.style.height = (newHeight + 'px');
                  expandLink.classList.add('expand-text__link--open');
                  expandLink.innerText = expandLink.getAttribute('data-text-more');
    
                  setTimeout(() => {
                    expandTextContent.style.height = 0 + 'px';
                    expandLink.classList.remove('expand-text__link--open');
                  }, 0);
                }
              });
            }
          }
        }
      }
    
      initCheckAllCookies () {
        let checkAllCookiesBtn = $('#check-all-cookies');
    
        if (!checkAllCookiesBtn.length) {
          return;
        }
    
        let inputAll = $('.bmw-cn-consent-checkbox[data-consent-type="all"]');
        let badgebox = checkAllCookiesBtn.parents('.block-bg-gray').find('.badgebox');
    
        if (window.bmwCookieBanner.getConsentStatus('all')) {
          inputAll.prop('checked', true);
          badgebox.css('display', 'flex');
          checkAllCookiesBtn.css('display', 'none');
        }
    
        checkAllCookiesBtn.on('click', (e) => {
          e.preventDefault();
          inputAll.trigger('click');
        });
    
        inputAll.on('input', () => {
          if(inputAll.is(':checked')) {
            badgebox.css('display', 'flex');
            checkAllCookiesBtn.css('display', 'none');
            window.bmwCookieBanner.giveConsentAndSaveAndLoad('all');
          } else {
            checkAllCookiesBtn.css('display', 'block');
            badgebox.css('display', 'none');
            window.bmwCookieBanner.rejectConsentAndSave('all');
          }
        });
      }
    }
    /**
     * Cookie Banner
     */
    
    class BMW_CookieBanner {
      constructor() {
        this.config = {
          debugMode: true,
          userConsents: {
            all: false
          },
          groups: [
            'all'
          ]
        };
    
        this.UI = {
          basicWindow: $('.bmw-cn-info'),
          buttons: {
            basicAcceptAll: $('.bmw-cn-info-button-accept-all')
          }
        };
    
        this.initPublicAPI();
    
        if (this.UI.basicWindow.length) {
          this.initEvents();
          this.checkConfig();
        } else {
          let config = Cookies.get('bmw-cn-config'); 
          
          if (config) {
            this.loadConfig(config);
          }
        }
      }
    
      checkConfig () {
        let config = Cookies.get('bmw-cn-config');
    
        // When no config - show popup
        if (!config) {
          if (this.config.debugMode) {
            console.log('⛔️ Consent config not found - showing popup');
          }
    
          this.showPopup();
          return;
        }
    
        // otherwise - load config without showing popup
        this.loadConfig(config);
      }
    
      loadConfig (configFromCookie) {
        this.config.userConsents.all = configFromCookie.indexOf('all') > -1;
    
        if (this.config.debugMode) {
          console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(this.config.userConsents)));
        }
      }
    
      initEvents () {
        this.UI.buttons.basicAcceptAll.on('click', e => {
          e.preventDefault();
          this.giveConsentForAll();
          this.closePopup();
        });
      }
    
      initPublicAPI () {
        window.bmwCookieBanner = {
          giveConsentAndSave: (type) => this.giveConsentAndSave(type),
          giveConsentAndSaveAndLoad: (type) => this.giveConsentAndSave(type, true),
          rejectConsentAndSave: (type) => this.rejectConsent(type),
          getConsentStatus: (type) => this.getConsentStatus(type)
        };
      }
    
      showPopup () {
        this.UI.basicWindow.removeClass('is-hidden');
      }
    
      closePopup () {
        this.UI.basicWindow.addClass('is-hidden');
      }
    
      giveConsentForAll () {
        this.giveConsent('all');
        this.saveConsentConfigInCookie();
      }
    
      giveConsent (type, forceOnLoad = false) {
        if (this.config.debugMode) {
          console.log('✅ User gave consent:', type);
        }
    
        this.config.userConsents[type] = true;
    
        if (type === 'all') {
          this.allowAll();
          return;
        }
      }
    
      rejectConsent (type) {
        if (this.config.debugMode) {
          console.log('✅ User reject consent:', type);
        }
    
        this.config.userConsents[type] = false;
        this.saveConsent();
      }
    
      giveConsentAndSave (type, forceOnLoad = false) {
        this.giveConsent(type, forceOnLoad);
        this.saveConsent();
      }
    
      saveConsent () {
        let consentCompare = this.compareConsents();
        
        // if some consent has been removed
        if (consentCompare === 'some-rejected') {
          this.saveConsentConfigInCookie();
          window.location.reload();
          return;
        }
    
        // otherwise - if some consent has been added
        this.saveConsentConfigInCookie();
      }
    
      saveConsentConfigInCookie () {
        let configToSave = [];
    
        for (let i = 0; i < this.config.groups.length; i++) {
          let group = this.config.groups[i];
    
          if (this.config.userConsents[group]) {
            configToSave.push(group);
          }
        }
    
        if (configToSave.length) {
          Cookies.set('bmw-cn-config', configToSave.join(';'), { expires: 180 });
    
          if (this.config.debugMode) {
            console.log('🍪 Consent config saved in the cookie');
          }
        } else {
          this.resetCookieConfig();
        }
      }
    
      resetCookieConfig () {
        Cookies.set('bmw-cn-config', 'null', { expires: 180 });
    
        if (this.config.debugMode) {
          console.log('🗑 User rejected all cookies - save empty config cookie');
        }
      }
    
      compareConsents () {
        let someRejected = false;
    
        for (let i = 0; i < this.config.groups.length; i++) {
          let group = this.config.groups[i];
    
          if (!this.config.userConsents[group]) {
            someRejected = true;
          }
        }
    
        if (someRejected) {
          if (this.config.debugMode) {
            console.log('🔄 Some consents has been rejected - website reload needed');
          }
    
          return 'some-rejected';
        }
    
        if (this.config.debugMode) {
          console.log('ℹ️ User not rejected any consents - website reload not needed');
        }
    
        return 'some-added-or-not-changed';
      }
    
      getConsentStatus (type) {
        return !!this.config.userConsents[type];
      }
    
      allowAll () {
        if (window.bmwUnlocked.indexOf('all') > -1) {
          return;
        }
    
        window.bmwUnlockConsentedScript('all', 'head', true);
      }
    }

    new BMW_Menu();
    new BMW_Tabs();
    new BMW_FormHelper();
    new BMW_ContestForm(); 
    new BMW_CookieBanner();
    new BMW_UI(); 
    new BMW_VoteForm();

    $(document).ready(function(){
        var contestCarousel = $('.contest-carousel');

        contestCarousel.owlCarousel({
            nav:false,
            loop:false,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    dots:true
                },
                560:{
                    items:2,
                    dots:true
                },
                720:{
                    items:3,
                    dots:false
                }
            }
        });
    });

    $(document).ready(function(){
        var masterclassCarousel = $('.masterclass-carousel');

        masterclassCarousel.owlCarousel({
            loop:true,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    dots:true,
                    nav:true
                },
                560:{
                    items:2,
                    dots:true,
                    nav:true
                },
                720:{
                    items:3,
                    dots:false,
                    nav:true
                }
            }
        });
    });

    $(document).ready(function(){
        var SliderMediaText = $('.slider-media-text-list');

        SliderMediaText.owlCarousel({
            items:1,
            nav: true,
            dots: true
        });
    });

    $(document).ready(function(){
        var SliderSubpage = $('.slider-subpage-list');

        SliderSubpage.owlCarousel({
            loop:true,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    dots:true,
                    nav:false
                },
                720:{
                    items:1,
                    dots:false,
                    nav:true
                }
            }
        });

        $('.btnprev').on('click', (e) => {
            e.preventDefault();
            SliderSubpage.trigger('prev.owl.carousel', [300]);
        })

        $('.btnnext').on('click', (e) => {
            e.preventDefault();
            SliderSubpage.trigger('next.owl.carousel');
        })
    });

})(jQuery);